import { render, staticRenderFns } from "./CorCol.vue?vue&type=template&id=c314da5c&scoped=true&"
import script from "./CorCol.vue?vue&type=script&lang=js&"
export * from "./CorCol.vue?vue&type=script&lang=js&"
import style0 from "./CorCol.vue?vue&type=style&index=0&id=c314da5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c314da5c",
  null
  
)

export default component.exports